<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px">
    <v-card class="item-dialog-card">
      <v-toolbar class="elevation-2" color="primary">
        <v-toolbar-title class="ml-0">
          <span class="font-weight-bold white--text">
            {{ $t('coinHistory.itemTitle') }}
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn @click="close" icon dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-0 pb-0 item-dialog-content">
        <v-container>
          <div v-if="item">
            <div v-if="item.image_url" class="text-center mb-4">
              <img
                :src="item.image_url"
                :alt="item.name"
                style="
                  max-height: 140px;
                  max-width: 100%;
                  object-fit: contain;
                " />
            </div>
            <v-simple-table class="do-not-apply-hover" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t('entities.invoices.attributes.id') }}</td>
                    <td class="font-weight-bold">{{ item.id }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('generalAttributes.name') }}</td>
                    <td class="font-weight-bold">{{ item.name || '—' }}</td>
                  </tr>
                  <tr v-if="item.description">
                    <td>{{ $t('generalAttributes.description') }}</td>
                    <td class="font-weight-bold">{{ item.description }}</td>
                  </tr>
                  <tr v-if="item.amount != null">
                    <td>{{ $t('generalAttributes.amount') }}</td>
                    <td class="font-weight-bold">{{ item.amount }}</td>
                  </tr>
                  <tr v-if="item.amount_percentage != null">
                    <td>{{ $t('coinHistory.amountPercentage') }}</td>
                    <td class="font-weight-bold">
                      {{ item.amount_percentage }}
                    </td>
                  </tr>
                  <tr v-if="item.duration != null">
                    <td>{{ $t('coinHistory.duration') }}</td>
                    <td class="font-weight-bold">
                      {{ formatDuration(item.duration) }}
                    </td>
                  </tr>
                  <tr v-if="item.used_at">
                    <td>{{ $t('coinHistory.usedAt') }}</td>
                    <td class="font-weight-bold">
                      {{ formatDateValue(item.used_at) }}
                    </td>
                  </tr>
                  <tr v-if="item.expires_at">
                    <td>{{ $t('coinHistory.expiresAt') }}</td>
                    <td class="font-weight-bold">
                      {{ formatDateValue(item.expires_at) }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('miscellaneous.createdAt') }}</td>
                    <td class="font-weight-bold">
                      {{ formatDateValue(item.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-card v-if="chestItems.length" class="mt-4 pb-2">
              <v-card-title class="pb-2">
                {{ $t('coinHistory.chestItems') }}
              </v-card-title>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="chestItem in chestItems" :key="chestItem.id">
                      <td>{{ chestItem.name }}</td>
                      <td v-if="chestItem.amount != null">
                        {{ chestItem.amount }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions class="item-dialog-actions">
        <v-spacer />
        <v-btn @click="close" color="dark darken-1" text>
          {{ $t('miscellaneous.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import formatDate from '@/mixins/format-date'

export default {
  name: 'CoinItemDialog',
  mixins: [formatDate],
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  computed: {
    chestItems() {
      return this.item?.chest_items || []
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    formatDateValue(value) {
      if (!value) return '—'
      const parsed = new Date(value)
      if (Number.isNaN(parsed.getTime())) return value
      return this.formatDate(parsed, true, true)
    },
    formatDuration(seconds) {
      if (seconds == null) return '—'
      const total = Number(seconds)
      if (!Number.isFinite(total) || total <= 0) return String(seconds)
      const days = Math.floor(total / 86400)
      const hours = Math.floor((total % 86400) / 3600)
      const mins = Math.floor((total % 3600) / 60)
      const secs = total % 60
      const parts = []
      if (days) parts.push(`${days}d`)
      if (hours) parts.push(`${hours}h`)
      if (mins) parts.push(`${mins}m`)
      if (secs) parts.push(`${secs}s`)
      return parts.join(' ') || `${total}s`
    },
  },
}
</script>

<style scoped>
.item-dialog-card {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.item-dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.item-dialog-actions {
  flex: 0 0 auto;
}
</style>
